"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormControl = void 0;
var react_1 = __importDefault(require("react"));
var VFlow_1 = require("../VFlow");
var styles_1 = require("../../styles");
var FormError_1 = require("./FormError");
var FormLabel_1 = require("./FormLabel");
function FormControl(props) {
    var children = props.children, htmlFor = props.htmlFor, error = props.error, label = props.label, labelId = props.labelId, errorId = props.errorId, inline = props.inline, required = props.required, style = props.style;
    var _a = styles_1.useStyles(createStyles), classes = _a.classes, css = _a.css;
    var isInline = inline && label;
    return (react_1.default.createElement(VFlow_1.VFlow, { vSpacing: 0 },
        react_1.default.createElement("div", { className: css([classes.formControl, isInline && classes.formControlInline, style]) },
            label && (react_1.default.createElement(FormLabel_1.FormLabel, { id: labelId, required: required, style: css(classes.label, isInline && classes.labelInline), markerStyle: isInline && classes.markerInline, htmlFor: htmlFor, label: label })),
            children),
        error && (react_1.default.createElement(FormError_1.FormError, { id: errorId, style: classes.error, role: 'alert' }, error))));
}
exports.FormControl = FormControl;
var createStyles = function () { return ({
    formControl: {},
    formControlInline: {
        display: 'grid',
        gridAutoFlow: 'column',
        gridTemplateColumns: 'min-content',
        alignItems: 'baseline',
        gridGap: '1rem',
    },
    label: {
        display: 'block',
        marginBottom: '0.25rem',
        lineHeight: '20px',
    },
    labelInline: {
        position: 'relative',
        whiteSpace: 'nowrap',
        marginBottom: 0,
    },
    markerInline: {
        position: 'absolute',
    },
    error: {
        marginTop: '0.25rem',
        lineHeight: '20px',
    },
}); };
//# sourceMappingURL=FormControl.js.map